module.exports = __webpack_public_path__ + "static/img/mll-register.8e08e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mll-register.png
// module id = 334
// module chunks = 32